import { HeroNumberWithFields } from "@aidkitorg/types/lib/survey";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useState, useEffect, useRef } from "react";
import { BooleanExprToFilterGroupConverter, FilterGroupToBooleanExprConverter } from "../../shared/utils/filterConverters";

export const useApplicantCountFormState = (component?: HeroNumberWithFields) => {
  const [title, setTitle] = useState<string>('Total Applicants');
  const [filterConfig, setFilterConfig] = useState<ReportFilterConfig | undefined>(undefined);
  const isInitialized = useRef(false);

  // Initialize form state from component if editing (only once)
  useEffect(() => {
    if (!component) return;

    if (isInitialized.current) {
      console.log('[useApplicantCountFormState] Skipping reinitialization - already initialized');
      return;
    }

    console.log('[useApplicantCountFormState] Initializing form state from component');

    // Initialize title
    if (typeof component.title === 'string') {
      setTitle(component.title);
    }

    if (component.filter) {
      try {
        const convertedFilter = BooleanExprToFilterGroupConverter.convert(component.filter);
        if (convertedFilter) {
          setFilterConfig({ enabled: true, config: convertedFilter });
        }
      } catch (error) {
        console.warn('Failed to convert saved filter config:', error);
      }
    }

    isInitialized.current = true;
  }, [component]);

  const buildApplicantCountObject = (): HeroNumberWithFields => {
    const applicantCount: HeroNumberWithFields = {
      kind: 'Hero Number',
      title: title,
      summary: {
        kind: 'Count'
      },
      useCommas: true,
    };

    // Add filter if it's configured
    if (filterConfig && filterConfig.enabled && filterConfig.config) {
      const booleanExpr = FilterGroupToBooleanExprConverter.convertFromConfig(filterConfig);
      if (booleanExpr) {
        applicantCount.filter = booleanExpr;
      }
    }

    return applicantCount;
  };

  const isFormStateValid = title.trim().length > 0;

  return {
    title,
    setTitle,
    filterConfig,
    setFilterConfig,
    buildApplicantCountObject,
    isFormStateValid
  };
};